// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.flag-module__flag___WBHo4 {
  display: table;
  width: 100%;
}
.flag-module__flag_custom-content___Hcxw3 {
  table-layout: fixed;
}

.flag-module__flag__image___tOX2s,
.flag-module__flag__body___gbEP0 {
  display: table-cell;
  vertical-align: middle;
}
.flag-module__flag--top___IF1UY .flag-module__flag__image___tOX2s,
.flag-module__flag--top___IF1UY .flag-module__flag__body___gbEP0 {
  vertical-align: top;
}
.flag-module__flag--bottom___dvbOJ .flag-module__flag__image___tOX2s,
.flag-module__flag--bottom___dvbOJ .flag-module__flag__body___gbEP0 {
  vertical-align: bottom;
}

.flag-module__flag__image___tOX2s {
  margin-right: 12px;
}
.flag-module__flag__image_medium___tSWL9 {
  width: 75px;
}
.flag-module__flag__image_small___qkkmU {
  width: 42px;
}
.flag-module__flag__image_top___UerE1 {
  vertical-align: top;
}
.flag-module__flag__image___tOX2s > picture > img,
.flag-module__flag__image___tOX2s > img {
  display: block;
  margin-right: 12px;
  max-width: none;
}
.flag-module__flag--rev___JhUeV .flag-module__flag__image___tOX2s {
  padding-right: 0;
  padding-left: 10px;
}

.flag-module__flag__body___gbEP0 {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./node_modules/wa-storybook/components/general/styles/flag.module.scss"],"names":[],"mappings":"AAEA;EACI,cAAA;EACA,WAAA;AADJ;AAEI;EACE,mBAAA;AAAN;;AAIA;;EAEI,mBAAA;EACA,sBAAA;AADJ;AAGI;;EACI,mBAAA;AAAR;AAGI;;EACI,sBAAA;AAAR;;AAKA;EACI,kBAAA;AAFJ;AAGI;EACE,WAAA;AADN;AAGI;EACE,WAAA;AADN;AAGI;EACE,mBAAA;AADN;AAII;;EAEI,cAAA;EACA,kBAAA;EACA,eAAA;AAFR;AAKI;EACI,gBAAA;EACA,kBAAA;AAHR;;AAQA;EACI,WAAA;AALJ","sourcesContent":["@import \"./variables.module.scss\";\n\n.flag {\n    display: table;\n    width: 100%;\n    &_custom-content {\n      table-layout: fixed;\n    }\n}\n\n.flag__image,\n.flag__body {\n    display: table-cell;\n    vertical-align: middle;\n\n    .flag--top & {\n        vertical-align: top;\n    }\n\n    .flag--bottom & {\n        vertical-align: bottom;\n    }\n\n}\n\n.flag__image {\n    margin-right: 12px;\n    &_medium {\n      width: 75px;\n    }\n    &_small {\n      width: 42px;\n    }\n    &_top {\n      vertical-align: top;\n    }\n\n    > picture > img,\n    > img {\n        display: block;\n        margin-right: $margin-sm + 2px;\n        max-width: none;\n    }\n\n    .flag--rev & {\n        padding-right: 0;\n        padding-left: 10px;\n    }\n\n}\n\n.flag__body {\n    width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"flag": `flag-module__flag___WBHo4`,
	"flag_custom-content": `flag-module__flag_custom-content___Hcxw3`,
	"flag__image": `flag-module__flag__image___tOX2s`,
	"flag__body": `flag-module__flag__body___gbEP0`,
	"flag--top": `flag-module__flag--top___IF1UY`,
	"flag--bottom": `flag-module__flag--bottom___dvbOJ`,
	"flag__image_medium": `flag-module__flag__image_medium___tSWL9`,
	"flag__image_small": `flag-module__flag__image_small___qkkmU`,
	"flag__image_top": `flag-module__flag__image_top___UerE1`,
	"flag--rev": `flag-module__flag--rev___JhUeV`
};
export default ___CSS_LOADER_EXPORT___;
